<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Saved description"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Event Type" label-position="inside">
                        <b-select expanded v-model="description.event_type">
                            <option :value="null">All Event Types</option>
                            <option v-for="t in eventTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="description.title"/>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Description">
                        <quill-editor v-model="description.description" :options="editorOptions" class="has-background-white content"/>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {EVENT_TYPES} from './eventTypes';

    export default {
        name: 'EventDescriptionForm',
        props: {
            description: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                eventTypes: EVENT_TYPES,
                // Same curated toolbar as the event Description field (TEN-80) —
                // this HTML gets copied verbatim onto events and rendered in Navigator.
                editorOptions: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline'],
                            [{ color: ['#000000', '#e60000', '#ffffff'] }, { background: ['#ffeb3b', '#ff9800', '#e60000'] }],
                            ['clean']
                        ]
                    }
                }
            };
        }
    };
</script>
